export const USER_COOKIE_NAME = 'fvSelfServiceUserCookie';